import { Children, FC, PropsWithChildren } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { Accordion as UIAccordion } from "@jti/ui/components/Accordion/Accordion";

import { Placeholder } from "../Placeholder/Placeholder";

import { accordionInputs } from "./Accordion.builder";

import styles from "./Accordion.module.scss";

export type AccordionBuilderProps = BuilderComponentProps<
  typeof accordionInputs
>;

export const Accordion: FC<PropsWithChildren<AccordionBuilderProps>> = ({
  children,
  singleExpanded,
  trackingEventType,
}) => {
  if (Children.count(children) === 0 && isEditing()) {
    return (
      <Placeholder>Drag and drop Accordion Item components here</Placeholder>
    );
  }

  const dispatchGTMEvent = (title: string) => {
    const trackingMap = {
      faq: {
        name: TrackingEvents.TrackingFaqLink,
        value: {
          faq_name: title,
        },
      },
    };

    if (trackingEventType && trackingEventType in trackingMap) {
      const { name, value } =
        trackingMap[trackingEventType as keyof typeof trackingMap];

      dispatchTrackingEvent(name, value);
    }
  };

  return (
    <div className={styles.accordionWrapper}>
      <UIAccordion
        singleExpanded={singleExpanded}
        dispatchGTMEvent={dispatchGTMEvent}
      >
        {children}
      </UIAccordion>
    </div>
  );
};
